import React, { FC } from 'react';

import { InverseButton } from '@crehana/ui';

interface ITemporal24HoursButton {
  isDark?: boolean;
  url?: string;
  temporalAccessDurationLabel?: string | null;
  isUserSofeAndCourseIsOneMonthOld?: boolean;
}

const Temporal24HoursButton: FC<ITemporal24HoursButton> = ({
  url,
  temporalAccessDurationLabel,
  isUserSofeAndCourseIsOneMonthOld,
  isDark,
}) => {
  return (
    <InverseButton
      full
      className="mt-16 rounded-10"
      href={url}
      label={temporalAccessDurationLabel || 'Acceso gratuito por 24 horas'}
      disabled={isUserSofeAndCourseIsOneMonthOld}
      isDark={isDark}
    />
  );
};

export default Temporal24HoursButton;
